/* istanbul ignore file */
export const APP_STORE_ID = '571641021';
